
import { defineComponent, PropType } from 'vue';

import { Picture } from '@/models/Muffin/picture';
import PrzPicture from '@/components/Muffin/Picture.vue';
import PrzBgVideo from '@/components/Blocks/Singles/Parts/BackgroundVideo/Component.vue';


export default defineComponent({
    components:{
        PrzPicture,
        PrzBgVideo
    },
    props: {
        url:{
            type: String,
            default: ''
        },
        urlQaTest:{
            type: String,
            default: undefined
        },
        video:{
            type: String,
            default: undefined
        },
        picture:{
            type: Object as PropType<Picture>,
            default: undefined
        },
        selected:{
            type: Boolean,
            default: false
        },
        activeTimeMs:{
            type: Number,
            default: 10000
        }
    },
    data(){
        let timer: any = null;
        return {
            play: false,
            timer
        }
    },
    watch:{
        selected:{
            async handler(val){
                let video: HTMLVideoElement|null = this.$el ? this.$el.querySelector('video') : null;
                let time: number = this.activeTimeMs;
                if(video){
                    if(val){
                        await video.play();
                        if(video.duration){
                            time = Math.ceil(video.duration * 1000) + 100;
                        }
                    }else{
                        video.pause();
                        video.currentTime = 0;
                    }
                }
                if(this.timer){
                    clearTimeout(this.timer);
                }
                if(val){
                    this.timer = setTimeout( () => this.timeEnd(), time);
                }
            },
            immediate: true
        }
    },
    methods:{
        onplay(){
            this.play = true;
        },
        timeEnd(){
            this.$emit('timeend');
        }
    }
});
